// extracted by mini-css-extract-plugin
export default {"subtitleContainer":"SubTitleBar_subtitleContainer__fXGdV","cb-fade-up":"SubTitleBar_cb-fade-up__FhQRW","adminActions":"SubTitleBar_adminActions__K148T"};